import session from './session';
import extension from './extension';
import tabs from './tabs';

export default [session, extension, tabs];
